import api from './client.js'

export const composAPI = {
  listResults:   (params) => api.get('/compos/results', { params }),
  leaderboard:   (params) => api.get('/compos/leaderboard', { params }),
  createResult:  (data)   => api.post('/compos/results', data),
  deleteResult:  (id)     => api.delete(`/compos/results/${id}`),
}
